import React from 'react';
import { Controller } from 'react-hook-form';
import LabelName from 'components/UI/LabelName/LabelName';
import FileDropzone from 'components/FileDropzone/FileDropzone';
import { downloadAttachments } from 'services/calendarServices';

const EVENT_ATTACH_ACCEPT =
  'application/pdf, application/msword, .docx, .doc, audio/*, video/*, image/*, .heic, .heif, image/heic, image/heif';

function EventAttachments({ control, setValue, getValues }) {
  const maxFiles = 20;

  const removeFile = (index) => {
    const updatedFiles = [...getValues('attachments')];
    updatedFiles.splice(index, 1);
    setValue('attachments', updatedFiles);
  };

  const onClickAttachments = (e, fileInfo) => {
    e.preventDefault();
    downloadAttachments(fileInfo)
      .then((data) => {
        let link = document.createElement('a');
        link.download = fileInfo.display_name;
        let url = window.URL.createObjectURL(data.Body);
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="d-flex py-2 flex-wrap">
        <div className="col-md-4 col-12 mt-2">
          <LabelName required={false} htmlFor="attachments">
            Attachments
          </LabelName>
        </div>
        <div className="col-md-8 col-12">
          <Controller
            name="attachments"
            control={control}
            defaultValue={[]}
            render={({ field }) => (
              <div>
                <FileDropzone
                  value={field.value || []}
                  onChange={(updated) => setValue('attachments', updated)}
                  accept={EVENT_ATTACH_ACCEPT}
                  maxFiles={maxFiles}
                  placeholder="Click or drag files to this area to upload"
                  className="font-bold attachment-input input-shadow"
                />
                <span className="ps-0">
                  {field?.value?.length > 0 &&
                    field.value.map((file, index) => (
                      <div key={index} className="my-2 d-flex">
                        <i className="fas fa-paperclip me-2 mt-1"></i>
                        <span
                          className={`${file instanceof File ? 'me-2' : 'link-primary pointer me-2'}`}
                          onClick={(e) => !(file instanceof File) && onClickAttachments(e, file)}
                        >
                          {file.file_name || file.display_name || file.name}
                        </span>
                        <i onClick={() => removeFile(index)} className="icon-delete ms-2 mt-1 pointer" style={{ cursor: 'pointer' }} />
                      </div>
                    ))}
                </span>
              </div>
            )}
          />
        </div>
      </div>
    </>
  );
}

export default EventAttachments;
